import React, { Component } from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'
import { connect } from 'react-redux'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'

import { GetWithNonce } from 'utils/axios-nonce'
import { Get, Post, Put } from 'utils/axios-token'
import Lang from 'Lang/General'

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      showCreateStages: false,
      loading: false,
      stages: [],
      searchParams: [
        {
          label: Lang[ 'FAIRS' ][ this.props.data.languageReducer.userSettings.admin_panel_language],
          value: 'fair_id',
          isNumeric: true,
          col: 6,
          param: '',
          type: 'select',
          options: []
        },
        {
          label: Lang[ 'TITLE' ][ this.props.data.languageReducer.userSettings.admin_panel_language],
          col: 6,
          value: 'title',
          param: ''
        },
      ],
      stagesMeta: {
        current_page: 1,
        per_page: 10,
        last_page: 1,
        total_results: 1
      },
      defaultQuery: {},
      selectedStages: null,
      showEditModal: false,
      subscribedPackage: false,
      showDeleteConfirmation: false,
      showViewStagesModal: false,
      fairs: [],
      countries: [],
      query: {}
    }

    onChangeStagesHOC = (key, val) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success(success)
    requestError = error => toast.error(error)

    getStages = (query) => {
      this.setState({ query })

      GetWithNonce(
        `/api/v1/fex/stages?query=${convertSearchObjectToBase64(query)}`,
        this.getStagesSuccess,
        this.getStagesError,
        this.load,
        this.props.data.languageReducer.userSettings.admin_panel_language
      )
    }
    getStagesSuccess = payload => this.setState({ 
      stages: payload.data,
      stagesMeta: payload.meta
    })
    getStagesError = error => this.requestError(error.toString())

    getFairs = () => {
      Get(
        `/api/v1/fex/fairs?query=${convertSearchObjectToBase64({
          page: 1,
          is_paginated: false,
          filter: {
            "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id,
            "is_active": true,
          }
        })}`,
        this.getFairsSuccess,
        this.getFairsError,
        this.load
      )
    }
    getFairsSuccess = payload => this.setState({ fairs: _.map(payload.data, child => ({
      label: child.title,
      value: child.short_title,
      name: child.short_title,
      id: child.id
    })) })
    getFairsError = error => this.requestError(error.toString())

    createStages = dataToSubmit => {
      Post(
        `/api/v1/fex/stages`,
        dataToSubmit,
        this.createStagesSuccess,
        this.createStagesError,
        this.load
      )
    }
    createStagesSuccess = () => {
      this.requestSuccess(Lang['RECORD_CREATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        showCreateStages: false,
        query: {
          page: 1,
          is_paginated: true,
          filter: {"client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id,}
        }
      }, () => this.getStages( this.state.query))
    }
    createStagesError = error => {
      if (error.name) {
        this.requestError(error.name)
      } else {
        this.requestError(error)
      }
    }

    getSelectedStages = id => {
      Get(
        `/api/v1/fex/stages/${id}`,
        this.getSelectedStagesSuccess,
        this.getSelectedStagesError,
        this.load
      )
    }
    getSelectedStagesSuccess = payload => this.setState({ selectedStages: payload, showEditModal: true })
    getSelectedStagesError = error => this.requestError(error)

    updateStages = (dataToSubmit) => {
      Put(
        `/api/v1/fex/stages/${dataToSubmit.id}`,
        dataToSubmit,
        this.updateStagesSuccess,
        this.updateStagesError,
        this.load
      )
    }
    updateStagesSuccess = () => {
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        showEditModal: false,
        selectedStages: null,
        query: {
          page: 1,
          is_paginated: true,
          filter: {"client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id,}
        }
      }, () => this.getStages( this.state.query))
    }
    updateStagesError = error => this.requestError(error)

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoadStagesHOC={this.state.loading}
          getFairs={this.getFairs}
          getStages={this.getStages}
          createStages={this.createStages}
          getSelectedStages={this.getSelectedStages}
          updateStages={this.updateStages}
          onChangeStagesHOC={this.onChangeStagesHOC}
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect(mapStateToProps)(WithHOC)
}

export default HOC
